import { usePage } from '../../contexts'
import styled from 'styled-components'
import { Outlet } from 'react-router-dom'
import { customTheme } from '../../styles/theme'

const BaseNoShadowLayout = ({ menuDefault, menuFooter }: any) => {
  const { background } = usePage()

  return (
    <>
      <FullWrapper>
        {background && <ImageBody src={background} />}
        <Outlet />
      </FullWrapper>
    </>
  )
}

export default BaseNoShadowLayout

const FullWrapper = styled.div`
  height: 100vh;
  overflow: hidden;

  @media (max-width: ${customTheme.breakpoints[1]}) {
    height: auto;
    min-height: 100vh;
    position: relative;
  }
`

const ImageBody = styled.img`
  position: absolute;
  height: 100%;
  width: 100%;
  object-fit: cover;
  z-index: -1;
`
